import { useNavigate } from "react-router-dom";
import { useBalanceStore } from "../../../_store/balanceStore";
import Container from "../../../components/layout/Container";
import { HeaderTitle } from "../../../components/header/Header";
import { HeaderReport } from "../components/header.main";
import numeral from "numeral";
import { CardBorderYellow } from "../components/cardMenu";
import {
  HeaderTableReport,
  HeaderTitleTableReport,
  TableReport,
} from "../components/table.main";
import { MTButton } from "../../../components/button/MTButton";
import TabPanelReport from "../components/tab.main";
import { useEffect, useMemo, useState } from "react";
import { first_reload } from "../../tax_plan/functions/firstLoad";
import {
  STYLE_BODY_DETAILS,
  STYLE_BODY_REPORT,
  STYLE_REPORT_CONTAIN,
} from "../../../utils/useStyle";
import {
  options_debt_long,
  options_debt_short,
  options_expenses_fixed,
  options_expenses_invest,
  options_expenses_invest_pdf,
  options_expenses_variable,
  options_other_income,
  options_other_income_interest,
  options_property_asset,
  options_property_intangible,
  options_property_invest,
  options_property_private,
} from "../../balance/functions";
import {
  calDebtLocalOption,
  calExpenseFixedOption,
  calExpenseVariableMonthOption,
  calExpenseVariableOption,
  calIncomeInterestLocalOption,
  calIncomeInterestOtherOption,
  calPropertyLocalOption,
  getBalanceItems,
} from "../../pdf/lib/pdf.lib";
import _ from "lodash";
import { PdfBalanceItemCard } from "../../pdf/component/pdf.c.card";
import { cn } from "../../../utils/useFunctions";
import {
  SumDebtPersonalValue,
  SumOtherDebtAmount,
} from "../../../functions/Balance/sumValueBalance";
import {
  sumCapitalInvest,
  sumDebtInvest,
} from "../../../functions/Balance/sumProperty";
import { ICON_WARNING } from "../../../utils/useIcons";
import ListDebtMain from "../../balance/component/VIListDebt";

const NetWealthSection = ({ balanceData }) => {
  // console.log("first", balanceData);

  const [addInvest, setAddInvest] = useState(
    balanceData?.property_invest_list ? balanceData?.property_invest_list : []
  );
  const [ReturnInsurance, setReturnInsurance] = useState([]);

  useEffect(() => {
    if (balanceData) {
      let tempInsuranceReturn = balanceData?.expenses_fixed_list
        ?.filter(
          (item) => item.options_expenses_fixed === "expenses_insuarant_life"
        )
        ?.map((item) => item.expenses_insuarant_lifes)
        ?.flat();

      let tempBalanceData = {};
      //=============เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)=============//

      if (
        balanceData?.property_invest_list
          ?.map((item) => item.options_property_invest_title)
          .includes("เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)") &&
        tempInsuranceReturn?.length === 0
      ) {
        // ถ้ามีหัวข้อนี้อยู่แล้ว
        let tempNameList = balanceData?.property_invest_list
          .find(
            (item) =>
              item?.options_property_invest_title ===
              "เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)"
          )
          ?.invest_other_lists?.filter((item) => item !== null)
          ?.map((item) => item?.title);

        let tempInvestList = balanceData?.property_invest_list?.map((item) => {
          if (item?.invest_other_lists) {
            let tempData = tempInsuranceReturn
              ?.map((item2) => {
                if (!tempNameList?.includes(item2.title))
                  return {
                    amount: item2?.more_details?.policy_surrender_value,
                    created: item2.created,
                    reward_amount_per_year: item?.reward_amount_per_year || 1,
                    target_invest: {},
                    title: item2.title,
                    editable: false,
                  };
              })
              .filter((item) => item !== undefined);
            return {
              ...item,
              invest_other_lists: [...item.invest_other_lists, ...tempData],
            };
          }
          return item;
        });

        tempBalanceData = tempInvestList;
      } else {
        // ถ้ายังไม่มีหัวข้อนี้อยู่
        let tempInvestList = tempInsuranceReturn?.map((item) => {
          return {
            amount: item?.more_details?.policy_surrender_value,
            created: item.created,
            reward_amount_per_year: item?.reward_amount_per_year || 1,
            target_invest: item?.target_invest || {},
            title: item.title,
            editable: true,
          };
        });

        tempBalanceData = tempInvestList;
      }
      setReturnInsurance(tempBalanceData);
    }
    //==============================================//
  }, [balanceData]);

  const status =
    balanceData?.debt_propotion >
    Number(balanceData?.sum_property_asset || 0) +
      SumDebtPersonalValue(balanceData) +
      sumCapitalInvest(addInvest, ReturnInsurance) +
      sumDebtInvest(balanceData) +
      Number(balanceData?.sum_property_private || 0) +
      SumOtherDebtAmount(balanceData) +
      Number(balanceData?.sum_property_intangible || 0)
      ? "bad"
      : "good";

  const amount = balanceData?.net_wealth;

  const property_value =
    Number(balanceData?.sum_property_asset || 0) +
    SumDebtPersonalValue(balanceData) +
    sumCapitalInvest(addInvest, ReturnInsurance) +
    sumDebtInvest(balanceData) +
    Number(balanceData?.sum_property_private || 0) +
    SumOtherDebtAmount(balanceData) +
    Number(balanceData?.sum_property_intangible || 0);

  const debt_value = balanceData?.debt_propotion;
  const net_wealth_value = balanceData?.net_wealth;

  const getNetWealth = useMemo(() => {
    let result = 0;
    if (balanceData?.property_propotion) {
      result = balanceData?.debt_propotion
        ? Number(balanceData?.property_propotion) -
          Number(balanceData?.debt_propotion)
        : 0;
    }
    if (result > 0) {
      return result;
    } else {
      return 0;
    }
  }, [balanceData?.property_propotion, balanceData?.debt_propotion]);

  const isWealthy = Number(net_wealth_value) > Number(debt_value);

  return (
    <CardBorderYellow
      title="งบดุล"
      results={numeral(balanceData?.net_wealth).format("0,0")}
      yellowWidth="w-[119px]"
      panel={
        <div className=" p-7">
          {status === "good" && (
            <div className=" grid grid-cols-2 gap-2  w-full h-full">
              <div className=" w-full h-full bg-[#C4F3BD] rounded-[4px] ">
                <div className=" flex flex-col justify-center items-center h-full ">
                  <img src="/images/wealth_green.svg" className="w-14" />
                  <div className=" text-mainblue font-medium text-md mt-[3px] ">
                    สินทรัพย์
                  </div>
                  <div className="text-mainblue font-semibold text-base leading-3 pt-1">
                    {numeral(property_value).format("0,0")} บาท
                  </div>
                </div>
              </div>
              <div className=" grid grid-rows-5 gap-2 ">
                <div
                  className={
                    " bg-[#FFCCCC] w-full h-full  rounded-[4px] py-2 " +
                    (isWealthy ? "row-span-2 " : "row-span-3 ")
                  }
                >
                  <div className=" flex flex-col justify-center items-center h-full ">
                    {!isWealthy && (
                      <img src="/images/debt_pdf2.svg" className="w-10" />
                    )}
                    <div className=" text-mainblue font-medium text-md mt-[3px] ">
                      หนี้สิน
                    </div>
                    <div className="text-mainblue font-semibold text-base leading-3 pt-1">
                      {numeral(debt_value).format("0,0")} บาท
                    </div>
                  </div>
                </div>
                <div
                  className={
                    " bg-[#CEE3FF] w-full h-full rounded-[4px] py-2 " +
                    (isWealthy ? "row-span-3 " : "row-span-2 ")
                  }
                >
                  <div className=" flex flex-col justify-center items-center h-full ">
                    {isWealthy && (
                      <img src="/images/wealth_blue.svg" className="w-10" />
                    )}
                    <div className=" text-mainblue font-medium text-md mt-[3px] ">
                      ความมั่งคั่งสุทธิ
                    </div>
                    <div className="text-mainblue font-semibold text-base leading-3 pt-1">
                      {numeral(net_wealth_value).format("0,0")} บาท
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {status === "bad" && (
            <div className="">
              <div className=" grid grid-cols-2 gap-2 w-full h-full">
                <div className="grid grid-rows-5 gap-2">
                  <div className=" row-span-2"></div>
                  <div className=" w-full h-full bg-[#C4F3BD] rounded-[4px] row-span-3 p-1.5 ">
                    <div className=" flex flex-col justify-center items-center h-full ">
                      <img src="/images/wealth_green.svg" className="w-14" />
                      <div className=" text-mainblue font-medium text-md mt-[3px] ">
                        สินทรัพย์
                      </div>
                      <div className="text-mainblue font-semibold text-base leading-3 pt-1">
                        {numeral(property_value).format("0,0")} บาท
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" w-full bg-[#FFCCCC] rounded-[4px] h-full p-1.5">
                  <div className=" flex flex-col justify-center items-center ">
                    <img src="/images/wealth_bad.svg" className="w-14 h" />
                    <div className=" text-mainblue font-medium text-md mt-[3px] ">
                      หนี้สิน
                    </div>
                    <div className="text-mainblue font-semibold text-base pt-1">
                      {numeral(debt_value).format("0,0")} บาท
                    </div>
                  </div>
                </div>
              </div>
              <div className=" border border-mainyellow rounded-[10px]  mx-9 mt-2.5 p-1 px-7 flex gap-[6px] items-center">
                <ICON_WARNING className={` w-7 h-7 text-mainyellow`} />
                <div className=" text-sm text-center text-mainblue">
                  <div>หากมีหนี้สินมากกว่าสินทรัพย์</div>
                  <div>ต้องระมัดระวังในการใช้จ่ายเงิน</div>
                </div>
              </div>
            </div>
          )}
        </div>
      }
    />
  );
};

const TableNetWealth = ({ propertyItems, propertyItemsDebt, balanceData }) => {
  // console.log("sss", balanceData);

  const PropertySection = () => {
    return (
      <div>
        <HeaderTableReport monthly="" />
        {propertyItems?.map((propertyItem, index) => {
          return (
            <div key={index} className="">
              <HeaderTitleTableReport
                img={`/images/${propertyItem?.icon}`}
                title={propertyItem?.label}
              />
              <div className={STYLE_BODY_REPORT}>
                {propertyItem.items?.map((item, index) => {
                  return (
                    <div className={cn(STYLE_BODY_DETAILS)}>
                      <div
                        className={` ${
                          item?.label === "รวม"
                            ? " text-base font-semibold "
                            : "font-medium "
                        }  text-left col-span-5 `}
                      >
                        {item?.label}
                      </div>
                      <div
                        className={` ${
                          item?.label === "รวม"
                            ? "text-base font-bold text-maincyan"
                            : "font-semibold text-mainblue"
                        }  col-span-3 text-right  `}
                      >
                        {numeral(item?.amount_per_year).format("0,0")} บาท
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
        <div className=" flex justify-between my-2.5">
          <div className=" text-sm font-medium">รวมสินทรัพย์ทั้งหมด</div>
          <div className="font-bold text-mainblue ">
            {/* {numeral(balanceData?.property_propotion)?.format("0,0")} บาท */}
            {numeral(
              propertyItems?.reduce((total, acc) => {
                return total + acc?.sum_total;
              }, 0)
            )?.format("0,0")}{" "}
            บาท
          </div>
        </div>
      </div>
    );
  };

  const DebtSection = () => {
    return (
      <div>
        <HeaderTableReport title="แหล่งที่มาของหนี้สิน" monthly="" />
        {propertyItemsDebt?.map((propertyItem, index) => {
          return (
            <div key={index} className="">
              <HeaderTitleTableReport
                img={`/images/${propertyItem?.icon}`}
                title={propertyItem?.label}
              />
              <div className={STYLE_BODY_REPORT}>
                {propertyItem.items?.map((item, index) => {
                  return (
                    <div className={cn(STYLE_BODY_DETAILS)}>
                      <div
                        className={` ${
                          item?.label === "รวม"
                            ? " text-base font-semibold "
                            : "font-medium "
                        }  text-left col-span-5 `}
                      >
                        {item?.label}
                      </div>
                      <div
                        className={` ${
                          item?.label === "รวม"
                            ? "text-base font-bold text-maincyan"
                            : "font-semibold text-mainblue"
                        }  col-span-3 text-right  `}
                      >
                        {numeral(item?.amount_per_year).format("0,0")} บาท
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
        <div className=" flex justify-between my-2.5">
          <div className=" text-sm font-medium">รวมสินทรัพย์ทั้งหมด</div>
          <div className="font-bold text-mainblue ">
            {numeral(balanceData?.debt_propotion)?.format("0,0")} บาท
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <PropertySection />
      <div className=" border-b border-gray55"></div>
      <DebtSection />
    </>
  );
};

const TableCashFlow = ({
  propertyItemsIncome,
  propertyItemsExpense,
  balanceData,
}) => {
  const sumExpensesDebtPerMonth = () => {
    let result = 0;
    if (balanceData?.sum_debt_short_permonth) {
      result += balanceData?.sum_debt_short_permonth;
    }
    if (balanceData?.sum_debt_long_permonth) {
      result += balanceData?.sum_debt_long_permonth;
    }
    return result;
  };
  // หายอดรวมค่าใช้จ่ายหนี้สินรายปีทั้งหมด
  const sumExpensesDebtPerYear = () => {
    let result = 0;
    result = sumExpensesDebtPerMonth() * 12;
    return result;
  };


  const IncomeSection = () => {
    return (
      <div>
        <HeaderTableReport title="แหล่งที่มาของรายรับ" monthly="" />
        {propertyItemsIncome?.map((propertyItem, index) => {
          return (
            <div key={index} className="">
              <HeaderTitleTableReport
                img={`/images/${propertyItem?.icon}`}
                title={propertyItem?.label}
              />
              <div className={STYLE_BODY_REPORT}>
                {propertyItem.items?.map((item, index) => {
                  return (
                    <div className={cn(STYLE_BODY_DETAILS)}>
                      <div
                        className={` ${
                          item?.label === "รวม"
                            ? " text-base font-semibold "
                            : "font-medium "
                        }  text-left col-span-5 `}
                      >
                        {item?.label}
                      </div>
                      <div
                        className={` ${
                          item?.label === "รวม"
                            ? "text-base font-bold text-maincyan"
                            : "font-semibold text-mainblue"
                        }  col-span-3 text-right  `}
                      >
                        {numeral(item?.amount_per_year).format("0,0")} บาท
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
        <div className=" flex justify-between my-2.5">
          <div className=" text-sm font-medium">รวมรายรับทั้งหมด</div>
          <div className="font-bold text-mainblue ">
            {numeral(balanceData?.salary_propotion)?.format("0,0")} บาท
          </div>
        </div>
      </div>
    );
  };
  const ExpenseSection = () => {
    return (
      <div>
        <HeaderTableReport title="แหล่งที่มาของรายรับ" monthly="" />
        {propertyItemsExpense?.map((propertyItem, index) => {
          return (
            <div key={index} className="">
              <HeaderTitleTableReport
                img={`/images/${propertyItem?.icon}`}
                title={propertyItem?.label}
              />
              {propertyItem?.label === "ค่าใช้จ่ายคงที่" && (
                <ListDebtMain sumExpensesDebtPerYear={sumExpensesDebtPerYear} />
              )}
              <div className={STYLE_BODY_REPORT}>
                {propertyItem.items?.map((item, index) => {
                  return (
                    <div className={cn(STYLE_BODY_DETAILS)}>
                      <div
                        className={` ${
                          item?.label === "รวม"
                            ? " text-base font-semibold "
                            : "font-medium "
                        }  text-left col-span-5 `}
                      >
                        {item?.label}
                      </div>
                      <div
                        className={` ${
                          item?.label === "รวม"
                            ? "text-base font-bold text-maincyan"
                            : "font-semibold text-mainblue"
                        }  col-span-3 text-right  `}
                      >
                        {" "}
                        {propertyItem?.label === "ค่าใช้จ่ายคงที่" &&
                        item?.label === "รวม"
                          ? numeral(balanceData?.sum_expenses_fixed).format(
                              "0,0"
                            )
                          : numeral(item?.amount_per_year).format("0,0")}
                        บาท
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
        <div className=" flex justify-between my-2.5">
          <div className=" text-sm font-medium">รายรับทั้งหมด</div>
          <div className="font-bold text-mainblue ">
            {numeral(balanceData?.salary_propotion)?.format("0,0")} บาท
          </div>
        </div>
        <div className=" flex justify-between my-2.5">
          <div className=" text-sm font-medium">รายจ่ายทั้งหมด</div>
          <div className="font-bold text-mainblue ">
            {numeral(
              Number(balanceData?.sum_expenses_fixed || 0) +
                Number(balanceData?.sum_expenses_variable || 0) +
                Number(balanceData?.sum_expenses_invest_saving || 0)
            )?.format("0,0")}{" "}
            บาท
          </div>
        </div>
        <div className=" flex justify-between my-2.5">
          <div className=" text-sm font-medium">กระแสเงินสดสุทธิ</div>
          <div className="font-bold text-mainblue ">
            {numeral(
              Number(
                Math.round((balanceData?.salary_propotion / 100) * 100) || 0
              ) -
                (Number(
                  Math.round((balanceData?.sum_expenses_fixed / 100) * 100) || 0
                ) +
                  Number(
                    Math.round(
                      (balanceData?.sum_expenses_variable / 100) * 100
                    ) || 0
                  ) +
                  Number(
                    Math.round(
                      (balanceData?.sum_expenses_invest_saving / 100) * 100
                    ) || 0
                  ))
            )?.format("0,0")}{" "}
            บาท
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <IncomeSection />
      <div className=" border-b border-gray55"></div>
      <ExpenseSection />
    </>
  );
};

const ReportBalancePage = () => {
  const navigate = useNavigate();
  const balanceData = useBalanceStore((state) => state.balanceData);

  const [isTab, setTab] = useState("netwealth");

  // สินทรัพย์
  const mergeOptions = useMemo(() => {
    return [
      {
        label: "สินทรัพย์สภาพคล่อง",
        key: "property_asset_list",
        key_option: "options_property_asset",
        options: options_property_asset,
        icon: "proporty_asset2.png",
      },
      {
        label: "สินทรัพย์เพื่อการลงทุน",
        key: "property_invest_list",
        key_option: "options_property_invest",
        options: options_property_invest,
        icon: "proporty_invest2.png",
      },
      {
        label: "สินทรัพย์ที่ไม่มีตัวตน",
        key: "property_intangible_list",
        key_option: "options_property_intangible",
        options: options_property_intangible,
        icon: "proporty_invest3.png",
      },
      {
        label: "สินทรัพย์ใช้ส่วนตัว",
        key: "property_private_list",
        key_option: "options_property_private",
        options: options_property_private,
        icon: "proporty_Intangible2.png",
      },
    ];
  }, []);

  const propertyItems = useMemo(() => {
    const items = getBalanceItems(balanceData, mergeOptions, calPropertyLocalOption);

    // เพิ่มมูลค่าเงินสดในกรมธรรม์จาก expenses_fixed_list (SumDebtPersonalValue)
    // เพราะ getBalanceItems ดึงแค่จาก property_invest_list
    const insuranceCashValue = SumDebtPersonalValue(balanceData) || 0;
    if (insuranceCashValue > 0) {
      const investGroup = items?.find(
        (item) => item?.label === "สินทรัพย์เพื่อการลงทุน"
      );
      if (investGroup) {
        const insuranceItem = investGroup?.items?.find(
          (item) =>
            item?.label === "มูลค่าเงินสดในกรมธรรม์ประกันชีวิต (ตราสารหนี้)"
        );
        if (insuranceItem) {
          insuranceItem.amount_per_year += insuranceCashValue;
        }
        // อัพเดทแถว "รวม" ด้วย
        const sumRow = investGroup?.items?.find(
          (item) => item?.label === "รวม"
        );
        if (sumRow) {
          sumRow.amount_per_year += insuranceCashValue;
        }
        investGroup.sum_total =
          (investGroup.sum_total || 0) + insuranceCashValue;
      }
    }

    return items;
  }, [balanceData]);

  // หนี้สิน
  const mergeOptionsDebt = useMemo(() => {
    return [
      {
        label: "หนี้สินระยะสั้น",
        key: "debt_short_list",
        key_option: "options_debt_short",
        options: options_debt_short,
        icon: "debt_short2.png",
      },
      {
        label: "หนี้สินระยะยาว",
        key: "debt_long_list",
        key_option: "options_debt_long",
        options: options_debt_long,
        icon: "debt_long2.png",
      },
    ];
  }, []);

  const propertyItemsDebt = useMemo(() => {
    return getBalanceItems(balanceData, mergeOptionsDebt, calDebtLocalOption);
  }, [balanceData]);

  // เงินเดือน
  const mergeOptionsIncome = useMemo(() => {
    return [
      {
        label: "ดอกเบี้ย",
        key: "interest_peryear_list",
        key_option: "option_interest",
        options: options_other_income_interest,
        icon: "credit-card.svg",
        calLocalOption: calIncomeInterestLocalOption,
      },
      {
        label: "โบนัส",
        key: "other_income_list",
        key_option: "option_income_other",
        options: options_other_income,
        icon: "credit-card.svg",
        calLocalOption: calIncomeInterestOtherOption,
      },
    ];
  }, []);

  const propertyItemsIncome = useMemo(() => {
    const tempPropertyItems = getBalanceItems(balanceData, mergeOptionsIncome);
    const newPropertyItems = [];

    let lastItem = {
      amount_per_year: 0,
      amount_per_month: 0,
      label: "รวม",
      returns: 100,
    };

    let salaryItem = {
      amount_per_year: 0,
      amount_per_month: 0,
      label: "เงินเดือนรวมทั้งปี",
      returns: 0,
    };

    if (balanceData?.salary_peryear_list?.length > 0) {
      for (const salary_peryear_item of balanceData?.salary_peryear_list) {
        salaryItem.amount_per_year += Math.abs(salary_peryear_item?.amount);
        salaryItem.amount_per_month += Math.abs(
          salary_peryear_item?.salary_permonth
        );
        lastItem.amount_per_year += Math.abs(salary_peryear_item?.amount);
        lastItem.amount_per_month += Math.abs(
          salary_peryear_item?.salary_permonth
        );
      }
    }

    newPropertyItems.push(salaryItem);

    for (const tempPropertyItem of tempPropertyItems) {
      const items = tempPropertyItem.items;
      for (const item of items) {
        if (item.label === "รวม") {
          continue;
        }
        lastItem.amount_per_year += item.amount_per_year;
        lastItem.amount_per_month += item.amount_per_month;
        newPropertyItems.push(item);
      }
    }

    for (const newPropertyItem of newPropertyItems) {
      newPropertyItem.returns =
        (newPropertyItem.amount_per_year / lastItem.amount_per_year) * 100;
    }

    newPropertyItems.push(lastItem);

    // console.log("newPropertyItems", newPropertyItems);
    return [
      {
        label: "เงินเดือน",
        icon: "salary_pdf.svg",
        items: newPropertyItems,
      },
    ];
  }, [balanceData]);

  // ค่าใช้จ่าย
  const mergeOptionsExpense = useMemo(() => {
    return [
      {
        label: "ค่าใช้จ่ายคงที่",
        key: "expenses_fixed_list",
        key_option: "options_expenses_fixed",
        options: options_expenses_fixed,
        icon: "accounting.svg",
        calLocalOption: calExpenseFixedOption,
        calLocalMonthOption: () => {
          return 0;
        },
      },
      {
        label: "ค่าใช้จ่ายเพื่อออม/ลงทุน",
        key: "expenses_invest_saving_list",
        key_option: "options_expenses_invest_pdf",
        options: options_expenses_invest_pdf,
        icon: "piggy-bank.svg",
        calLocalOption: calExpenseVariableOption,
        calLocalMonthOption: calExpenseVariableMonthOption,
      },
      {
        label: "ค่าใช้จ่ายแปรผัน",
        key: "expenses_variable_list",
        key_option: "options_expenses_variable",
        options: options_expenses_variable,
        icon: "cost (1).svg",
        calLocalOption: calExpenseVariableOption,
        calLocalMonthOption: () => {
          return 0;
        },
      },
    ];
  }, [balanceData]);

  const propertyItemsExpense = useMemo(() => {
    let tempGetBalanceItems = getBalanceItems(balanceData, mergeOptionsExpense);

    tempGetBalanceItems?.map((data) => {
      let temp = data?.items;

      if (data?.label === "ค่าใช้จ่ายเพื่อออม/ลงทุน") {
        temp?.map((item2) => {
          if (item2.label === "ค่าใช้จ่ายเพื่อออม/ลงทุนเพิ่มเติม") {
            item2.amount_per_year = balanceData?.sum_expenses_invest_saving;
            item2.amount_per_month =
              balanceData?.sum_expenses_invest_saving / 12;
          }

          return item2;
        });

        let totalAmount = temp?.reduce((acc, item) => {
          if (item.label === "รวม") {
            return acc;
          }
          return acc + Number(item?.amount_per_year || 0);
        }, 0);

        temp?.map((item2) => {
          item2.returns = (item2?.amount_per_year / totalAmount) * 100;

          return item2;
        });

        temp?.map((item2) => {
          if (item2.label === "รวม") {
            item2.returns = temp?.reduce((acc, item) => {
              if (item.label === "รวม") {
                return acc;
              }
              return acc + Number(item?.returns || 0);
            }, 0);
            item2.amount_per_year = temp?.reduce((acc, item) => {
              if (item.label === "รวม") {
                return acc;
              }
              return acc + Number(item?.amount_per_year || 0);
            }, 0);
          }

          return item2;
        });
      }

      return data;
    });

    return tempGetBalanceItems;
  }, [balanceData]);

  useEffect(() => {
    let ignore = false;
    first_reload(ignore);
    return () => {
      ignore = true;
    };
  }, []);

  return (
    <Container>
      <div id="first_reload" className="pt-[14px]">
        <HeaderTitle
          title="รายงาน"
          isGoback
          onClickGoBack={() => {
            navigate("/report");
          }}
        />

        <div className={STYLE_REPORT_CONTAIN}>
          <HeaderReport icon={"/images/balance-report.png"} title={"งบดุล"} />
          <div className=" flex flex-col gap-5 mt-[17px] ">
            <NetWealthSection balanceData={balanceData} />

            <div className="bg-gray50 rounded-[20px] w-full h-ful">
              <div className=" p-3">
                <TabPanelReport
                  title_tab1={"ความมั่งคั่ง"}
                  title_tab2={"กระแสเงินสด"}
                  onTab1={() => setTab("netwealth")}
                  tab1={isTab === "netwealth" ? true : false}
                  onTab2={() => setTab("cashflow")}
                  tab2={isTab === "cashflow" ? true : false}
                />
              </div>
              <div className=" p-3 bg-[#FCFCFC] rounded-b-[20px]">
                {isTab === "netwealth" ? (
                  <TableNetWealth
                    propertyItems={propertyItems}
                    propertyItemsDebt={propertyItemsDebt}
                    balanceData={balanceData}
                  />
                ) : (
                  <TableCashFlow
                    propertyItemsIncome={propertyItemsIncome}
                    propertyItemsExpense={propertyItemsExpense}
                    balanceData={balanceData}
                  />
                )}
              </div>
            </div>
          </div>
          <div className=" flex justify-center mt-5">
            <MTButton
              onClick={() => {
                navigate("/report");
              }}
              text="ย้อนกลับ"
              color="bg-white"
              border="border border-maincyan"
              colortext="text-maincyan group-hover:text-white"
              hovercolor="hover:bg-maincyan group "
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ReportBalancePage;
